import Text from '../UI/Text';
import Title from '../UI/Title';

const Funding = () => (
  <>
    <Title>מידע ומימון</Title>
    <Text>
      <p>
        חברת רשת – דירוגים נבחרה על ידי EXPERIAN תאגיד המידע המוביל בעולם להפיץ את מוצריה בישראל.חברת Funding הינה מחברות המידע
        העסקי הגדולות בעולם העוזרת למנהלים לקבל החלטות אשראי טובות יותר.
        <br />
        אודות החברה:
      </p>
      <div className='mx-auto w-3/4'>
        <ul className='flex justify-evenly list-inside flex-col md:flex-row flex-wrap space-y-4 space-x-2 space-x-reverse space-y-reverse list-disc mx-auto my-6'>
          <li className='flex-shrink-0'>40 סניפים בעולם</li>
          <li className='flex-shrink-0'>5 מיליארד $ מחזור עסקי.</li>
          <li className='flex-shrink-0'>16,000 מועסקים.</li>
          <li className='flex-shrink-0'>חברה ציבורית הנסחרת בלונדון.</li>
          <li className='flex-shrink-0'>כיסוי חברות גלובאלי.</li>
        </ul>
      </div>

      <p className='text-center'>מידע על מעל ל - 100 מליון חברות בעולם כל דוח סיכון אשראי מכיל:</p>

      <div className='mx-auto w-3/4'>
        <ul className='flex text-right justify-evenly list-inside flex-col md:flex-row flex-wrap space-y-4 space-x-2 space-x-reverse space-y-reverse list-disc mx-auto my-6'>
          <li className='flex-shrink-0'>המלצת אשראי לחברה</li>
          <li className='flex-shrink-0'>דירוג סיכון אשראי</li>
          <li className='flex-shrink-0'>פרטי זיהוי לחברה</li>
          <li className='flex-shrink-0'>בעלות והנהלה</li>
          <li className='flex-shrink-0'>ועוד מידע משפטי, מוסר תשלומים</li>
        </ul>
      </div>
      <br />
      <p>הפתרונות העיקריים אותם אנו משווקים: </p>
      <br />
      <p>
        דוחות פיננסיים על חברות ועסקים.
        <br />
        מאגרים שיווקיים לפי הזמנה- איתור לקוחות וספקים לפי הגדרות שונות.
        <br />
        מערכות בינה מתוחכמות המאגדות את כלל הלקוחות והספקים בעולם במקום אחד
      </p>
    </Text>
  </>
);

export default Funding;
